import { toast } from 'sonner';

import { useCreateBrandMutation } from '@/features/slice/products/brand/brand-api-slice';
import { useModal } from '@/hooks';
import { BrandForm } from '@/modules/products/brand/brand-form.component';
import { toastError } from '@/utils';

export const CreateBrand = () => {
    const [createBrand, { isLoading }] = useCreateBrandMutation();
    const { closeModal } = useModal();

    const handleSubmit = async (values: {
        name: string;
        description: string;
    }) => {
        try {
            await createBrand(values).unwrap();
            toast.success('Brand has been created');
            closeModal();
        } catch (error) {
            toastError(
                error,
                'CreateBrand: handleSubmit -> Failed to create brand.',
            );
        }
    };

    return (
        <BrandForm
            initialValues={{ name: '', description: '' }}
            onSubmit={handleSubmit as any}
            isLoading={isLoading}
            title={'Create Brand'}
        />
    );
};
